module.exports = __webpack_public_path__ + "abbefe0a25933ed2fb23fce3568b5e71.png";